import type { AutocompleteOption } from '@citibox-panel/ui';

// The stand-in's id. A STRING on purpose, where every real location id is an integer ([AS-037]):
// the two id spaces cannot meet, so «is this the address it loaded with?» can never be confused
// with «is this building number N?». If this ever becomes a number, the location whose id it
// collides with is read as «unchanged» and the write silently sends no `location_id`.
export const STANDIN_ID = 'current-address';

// The address the ficha loaded with, wrapped so the combobox can SHOW it while it is not a real
// choice. It cannot be matched against the suggestions: the two strings are different data — a
// suggestion embeds the matrícula where the ficha's text does not — and the ficha stores the
// address as text with no id attached. So it enters as its own option and leaves as one, and only
// an explicit pick replaces it with something that has an id to send.
//
// Null when there is nothing to stand in for — a pre-registered or anonymized account. Null and
// not an empty label: an option labelled '' is a blank row the agent can pick.
export function standInOption(address: string): AutocompleteOption | null {
  const trimmed = address.trim();
  if (trimmed === '') return null;
  return { id: STANDIN_ID, label: trimmed };
}

// Whether what is selected is still the loaded address rather than a chosen building. This is what
// decides if `location_id` travels in the body at all.
export function isStandIn(option: AutocompleteOption | null): boolean {
  return option?.id === STANDIN_ID;
}
